export const REM_TO_PX_RATIO = 16
export const pxToRem = pxValue => `${(1 / REM_TO_PX_RATIO) * pxValue}rem`
